import { Box, Stack } from '@mui/material';
import { VulcainHeader } from '@vestiaire/vc-vulcain-component-library';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@/context/Authentication.context';
import { environments } from '@/environments';
import Logo from './Logo';

import '@vestiaire/design-system/dist/css/main.min.css';
import '@vestiaire/vc-vulcain-component-library/style.css';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuthContext();
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        gap: 1,
        alignItems: 'center',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: 'sticky',
        top: 0,
        color: (theme) => theme.palette.text.primary,
        '& .vc-header': {
          background: (theme) => theme.palette.background.paper,
          color: (theme) => theme.palette.text.primary,
          borderBottomColor: (theme) => theme.palette.borderColor.main,
        },
        '& .vc-btn--ghost': {
          color: (theme) => theme.palette.text.primary,
          borderColor: 'white',
        },
        '& .vc-dropdown__menu--items': {
          background: (theme) => theme.palette.background.default,
          color: (theme) => theme.palette.text.primary,
        },
      }}
    >
      <Box sx={{ position: 'absolute', zIndex: 900, left: 16 }}>
        <Logo />
      </Box>

      <Stack sx={{ flex: '1 1 auto' }}>
        <VulcainHeader
          title={{
            title: t('QCD.COMMON.TOOL_NAME'),
            link: '/',
          }}
          onLogout={() => {
            logout();
          }}
          menu={{
            appsLink: environments.loginUrl,
            loginTitle: 'Login',
            logoutTitle: 'Logout',
            preferencesLink: `${environments.loginUrl}/user/preferences`,
          }}
          onLogin={() => {
            window.location.href = environments.loginUrl;
          }}
          user={isAuthenticated && user}
        />
      </Stack>
    </Stack>
  );
};

export default Header;
